<mat-card class="offer_start">
  <app-image-offer [matCard]="true" [offerKey]="offer.offerKey" [height]="'250px'"></app-image-offer>

  <mat-card-content>
    <div class="photo_experience" *ngIf="offer?.photoExperience">
      <p>{{offer?.photoExperience || 'Photo expérience'}}</p>
    </div>

    <div class="infos_sub_img">
      <div class="infos">
        <div class="icon">
          <fa-icon [icon]="faClock"></fa-icon>
        </div>
        {{offer?.duration || "Durée de l'activité"}}
      </div>
      <div class="infos">
        <div class="icon">
          <fa-icon [icon]="faMapMarkedAlt"></fa-icon>
        </div>
        <p>
          {{offer?.practicePlace || "lieu de partique" }}
        </p>
      </div>
    </div>

    <h4><strong>{{offer?.offerName || "Nom de l'offre"}}</strong></h4>

    <div class="tags">
      <ng-container *ngFor="let t of offer?.mainTags, let i = index">
        <div class="tag"> {{t.tagName}} </div>
      </ng-container>
    </div>

    <p class="description" [innerHTML]="offer?.description">
      <!-- {{ offer?.description ? (offer?.description | textDescription) :'Description de l\'offre'}} <span
          *ngIf=" offer?.description?.length > 200"  appChangeColorTheme attribute="color">plus</span> -->
    </p>
  </mat-card-content>

  <div class="btn_action">
    <div class="price">
      <div class="icon">
        <fa-icon [icon]="faEuroSign" appChangeColorTheme attribute="color"></fa-icon>
      </div>
      <span> {{offer?.price || 'Prix de l\'offre'}} </span>
    </div>
    <fa-icon [icon]="faHeartEmpty" appChangeColorTheme attribute="color">
    </fa-icon>
  </div>

</mat-card>